"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioRemoteDataTrack = exports.TwilioLocalDataTrack = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const rxjs_1 = require("rxjs");
class TwilioLocalDataTrack {
    constructor(track) {
        this.kind = 'dataTrack';
        this.track = track;
    }
    send(message) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.track.send(streem_sdk_protobuf_1.streem.room.DataTrackMessage.encode(message).finish());
        });
    }
}
exports.TwilioLocalDataTrack = TwilioLocalDataTrack;
class TwilioRemoteDataTrack {
    constructor(track) {
        this.kind = 'dataTrack';
        this.messages = new rxjs_1.Observable(subscriber => {
            const messageHandler = (data) => {
                const msg = streem_sdk_protobuf_1.streem.room.DataTrackMessage.decode(new Uint8Array(data));
                subscriber.next(msg);
            };
            track.on('message', messageHandler);
            subscriber.add(() => {
                track.off('message', messageHandler);
            });
        });
    }
}
exports.TwilioRemoteDataTrack = TwilioRemoteDataTrack;
//# sourceMappingURL=data_tracks.js.map